var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronSmRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 16.0003C10.8024 15.9993 10.6096 15.9397 10.4458 15.8292C10.2821 15.7187 10.1547 15.5622 10.0798 15.3793C10.0049 15.1965 9.98587 14.9956 10.0251 14.802C10.0642 14.6083 10.1599 14.4306 10.3 14.2913L12.6 12.0053L10.314 9.7053C10.1576 9.51311 10.0782 9.26972 10.0911 9.0223C10.1039 8.77488 10.2082 8.54105 10.3836 8.36611C10.5591 8.19117 10.7932 8.08758 11.0406 8.07542C11.2881 8.06327 11.5313 8.1434 11.723 8.3003L14.714 11.3003C14.9015 11.4878 15.0068 11.7421 15.0068 12.0073C15.0068 12.2725 14.9015 12.5268 14.714 12.7143L11.7 15.7093C11.5139 15.8944 11.2625 15.9989 11 16.0003Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronSmRight);
export default __webpack_public_path__ + "static/media/chevron-sm-right.6886b8b4f6c9b534f5208eb909045fc2.svg";
export { ForwardRef as ReactComponent };